var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209.46 175.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1d1d1b;\n        font-family: Montserrat-Regular, 'Montserrat Regular';\n        font-size: 7.26px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke: #fff;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: .75px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-4 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        stroke-width: .5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.68.5c4.37,3.14,5.7,8.04,6.53,12.8,1.6,9.19,2.83,18.46,3.64,27.75.42,4.8.99,8.78,6.35,10.42,1.85.57,3.45,1.94,5.63,3.22.28-3.57.48-6.72.77-9.85.35-3.7.76-7.4,1.18-11.09.06-.57.21-1.55.5-1.62,3.58-.84,2.92-4.07,3.74-6.45.19-.57.25-1.24.59-1.69.86-1.15,1.84-2.2,2.78-3.29.87,1.12,1.98,2.13,2.56,3.38.62,1.34.61,2.95,1.14,4.35.45,1.19,1.29,2.22,1.92,3.34.68,1.21,1.78,2.4,1.9,3.68.62,6.7.99,13.43,1.48,20.49,6.13.46,12.32.93,18.5,1.38,13.65,1.01,27.3,2.02,40.96,2.99,2.13.15,3.18,1.34,3.11,3.3-.12,3.51-.21,7.06-.85,10.5-.22,1.17-1.94,2.7-3.18,2.93-18.68,3.42-37.39,6.7-56.12,9.87-2.91.49-5.03,1.08-4.58,4.66.1.76-.26,1.58-.41,2.37-.36,1.94.44,4.31-2.04,5.47-3.74,1.75-7.41,1.27-10.94-.54-.54-.27-.77-1.36-.92-2.12-.38-1.96-.64-3.94-1.03-6.4-3.38.59-6.71.84-9.78,1.86-1.17.39-2.37,2.46-2.52,3.88-.77,7.2-1.12,14.44-1.79,21.66-.7,7.6-1.61,15.18-2.4,22.77-.1.98-.01,1.97-.01,3.18,7.49,1.25,14.9,2.49,22.32,3.71,4.16.68,8.34,1.28,12.51,1.98,3.36.56,4.59,1.97,4.28,5.37-.17,1.86-.74,3.76-1.52,5.47-.36.79-1.6,1.57-2.51,1.66-12.02,1.12-24.06,2.14-36.09,3.13-3.64.3-5.44,2.06-5.67,5.72-.08,1.25-.32,2.49-.48,3.74-.28.02-.57.03-.85.05-.21-1.17-.44-2.34-.63-3.52-.61-3.75-2-5.89-6.05-6.12-11.95-.67-23.87-1.89-35.79-3.01-.9-.08-2.08-.91-2.48-1.71-.74-1.49-1.25-3.2-1.41-4.87-.4-4.08.81-5.37,4.87-6.02,11.01-1.77,22.01-3.6,33.02-5.42.38-.06.75-.18,1.39-.34-.47-3.95-1.03-7.8-1.37-11.67-1-11.63-1.99-23.26-2.8-34.9-.22-3.12-1.38-4.88-4.53-5.3-2.58-.34-5.14-.8-7.92-1.23-.3,1.5-.5,2.76-.81,3.99-.47,1.8.21,3.93-2.36,5.03-3.74,1.6-7.21,1.24-10.67-.45-.47-.23-.71-1.16-.84-1.81-.25-1.18-.3-2.4-.51-3.58-1-5.8-.99-5.88-6.72-6.9-17.8-3.18-35.61-6.33-53.44-9.38-2.73-.47-4.16-1.62-4.27-4.43-.12-3.11-.43-6.22-.53-9.33-.07-2.05,1.08-3.09,3.15-3.24,13.65-.98,27.31-1.99,40.96-2.99,6.11-.45,12.22-.9,18.55-1.37.24-4.4.46-8.69.72-12.97.14-2.31.53-4.61.52-6.91,0-2.1.6-3.58,2.46-4.71.71-.43,1.08-1.58,1.37-2.49.61-1.9.93-3.89,1.64-5.75.35-.92,1.3-1.6,1.98-2.39.85.76,2.08,1.36,2.48,2.31.8,1.91,1.1,4.03,1.72,6.02.24.75.67,1.85,1.24,2.02,2.05.61,2.41,1.98,2.56,3.85.51,6.4,1.17,12.78,1.82,19.62,3.68-2.08,7.19-3.95,10.55-6.06.61-.38.7-1.76.82-2.7,1.41-10.96,2.52-21.96,4.28-32.86.75-4.66,2.12-9.47,6.52-12.44h1.81ZM97.28,60.82c-4.27-.03-4.4-.02-4.23,4.21.7,17.69,1.54,35.37,2.22,53.06.27,6.9.07,5.72,5.95,6.04-.86.04-1.71,0-2.57.05-.86.04-1.72.14-2.81.24,1.46,14.09,3.4,27.81,6.95,41.26.26.97,1.06,1.8,2.06,3.43.93-2.03,1.84-3.28,2.07-4.64,2.44-14.67,5.38-29.29,6.95-44.06,1.47-13.88,1.64-27.91,2.06-41.88.58-19.52-.07-39.01-3.2-58.31-.89-5.46-2.77-10.86-4.88-16-1.47-3.58-4.45-3.54-6.25-.1-1.61,3.08-2.81,6.45-3.68,9.82-3.23,12.45-3.28,25.28-4.3,37.99-.22,2.76-.29,5.53-.43,8.48M63.02,57.02c-.5-.04-.9-.13-1.28-.11-14.06,1-28.13,2.01-42.19,3.03-4.72.34-9.44.7-14.16,1.05-3.77.28-4.25.77-4.15,4.58.05,1.91.29,3.81.43,5.72.32,4.23.7,4.6,4.94,5.35,12.29,2.15,24.57,4.34,36.85,6.5,6.91,1.21,13.83,2.39,20.86,3.6-.44-10-.86-19.7-1.3-29.72ZM145.11,86.62c1.16-.14,2.24-.22,3.3-.4,16.54-2.92,33.08-5.86,49.63-8.78,10.04-1.77,10.41-2.3,10.21-12.43-.06-2.79-1.08-3.85-3.85-4.04-16.47-1.11-32.94-2.37-49.41-3.55-2.86-.21-5.72-.32-8.54-.48-.45,10.07-.89,19.77-1.34,29.68ZM72.89,21.42c-.57.05-1.13.1-1.7.15-.6,2.37-1.12,4.76-1.84,7.08-.35,1.13-.81,2.54-1.68,3.13-1.7,1.14-2.39,2.58-2.48,4.48-.36,7.52-1.18,15.04-.96,22.54.34,11.66,1.36,23.29,2.13,34.93.31,4.75.97,5.41,5.62,5.98,3.65.44,6.57-1.61,7.03-4.98,2.68-19.36,2.26-38.73.17-58.11-.24-2.18-.23-4.37-3.02-5.23-.6-.18-.78-1.8-1.09-2.78-.75-2.39-1.46-4.79-2.18-7.19ZM138.05,21.14c-2.69,2.3-3.35,3.96-3.71,7.67-.09.9-.44,2.36-.99,2.53-2.86.89-2.91,3.21-3.17,5.46-.25,2.2-.46,4.41-.62,6.61-1.26,16.99-1.63,33.98.87,50.91.54,3.67,2.67,5.49,6.35,5.48,4.01-.01,6.06-1.61,6.32-5.05.99-13.17,2.95-26.28,1.61-39.57-.6-5.92-.25-11.93-.39-17.91-.05-2.37-.55-4.48-2.98-5.78-.71-.38-.95-1.76-1.24-2.73-.71-2.42-1.32-4.86-2.05-7.61ZM101.28,164.38c-1.33-6.73-2.6-13.17-3.92-19.84-11.6,1.9-22.98,3.74-34.35,5.63-3.67.61-4.45,1.58-4.25,4.88.26,4.29,1.57,5.91,4.94,6.2,6.5.56,13,1.17,19.5,1.72,5.98.5,11.96.94,18.08,1.42ZM108.15,164.47c13.31-1.15,26.32-2.13,39.28-3.51,2.83-.3,3.13-3.45,3.1-5.81-.03-2.02.07-4.45-3.09-4.85-4.28-.55-8.52-1.38-12.78-2.08-7.5-1.22-15-2.43-22.58-3.66-1.31,6.66-2.57,13.03-3.92,19.91ZM92.6,91.72v-42.28c-3.16,1.79-5.98,3.51-8.91,5-1.66.84-2.17,1.88-2.15,3.76.07,7.54-.04,15.08-.17,22.62-.05,2.86-.36,5.72-.55,8.53,4.15.83,7.95,1.6,11.79,2.37ZM128.44,89.4c.1-.35.2-.54.2-.73-.24-10.54-.47-21.08-.78-31.62-.02-.66-.5-1.57-1.04-1.9-3.22-1.94-6.53-3.74-9.94-5.66v42.23c3.8-.76,7.6-1.52,11.56-2.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "103.34 167.99 104.48 103.13 105.96 167.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 94.27,
    y1: 31.59,
    x2: 114.34,
    y2: 31.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.27,36.69s8.96-10.54,20.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.57,36.01v-3.98s1.32,0,1.32,0v3.98"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "60.26 149.96 60.26 152.68 60.26 160.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "99.49 156.65 65.24 156.65 65.24 152.45 60.26 152.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "79.87 162.89 79.87 160.39 95.52 161.07 95.52 164.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "95.52 124.11 102.66 124.11 102.66 113.11 94.27 113.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.27,
    y: 94.17,
    width: 7.6,
    height: 9.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.27,
    y: 78.75,
    width: 7.6,
    height: 11.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.27,
    y: 63.67,
    width: 7.03,
    height: 10.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.28,58.91l-1.76-3.29v-5.33s1.59-3.74,2.95,0h1.59s1.59-4.54,2.61,0v5.56l-1.36,3.06h-4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.64,49.61s.05,8.66-.22,18.03c-.31,11.06-1.06,23.13-2.84,23.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.01,
    y1: 67.42,
    x2: 90.43,
    y2: 67.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.01,
    y1: 82.5,
    x2: 89.5,
    y2: 83.83
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "67.06 95.53 67.06 81.82 68.76 80.11 77.26 80.11 78.17 81.47 78.17 96.9 68.42 96.9 67.06 95.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.81,
    y: 56.3,
    width: 12.36,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "80.33 55.28 63.66 55.28 63.66 58.23 3.11 62.43 3.11 60.84 3.11 67.42 3.11 71.95 3.11 76.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.32,
    y1: 67.42,
    x2: 3.11,
    y2: 67.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "3.11 71.95 36.76 76.75 64.34 80.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 36.79,
    y1: 81.93,
    x2: 36.76,
    y2: 76.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 64.34,
    y1: 34.34,
    x2: 79.3,
    y2: 34.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.76,28.98c0-.71-3.75-1.32-6.35-1.47-3.13-.18-7.31.15-7.37.91-.06.73,3.69,1.86,7.26,1.93,3.07.05,6.46-.68,6.46-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.11,29.09c0-.65,4.07-1.24,7.37-1.25,3.73-.01,7.94.7,7.94,1.36,0,.64-3.92,1.2-7.03,1.25-3.92.06-8.28-.68-8.28-1.36Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.76,
    y1: 28.98,
    x2: 75.11,
    y2: 29.09
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "103.34 167.99 104.48 103.13 105.96 167.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 94.27,
    y1: 31.59,
    x2: 114.34,
    y2: 31.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.27,36.69s8.96-10.54,20.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.57,36.01v-3.98s1.32,0,1.32,0v3.98"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "149.07 149.96 149.07 152.68 149.07 160.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "109.83 156.65 144.08 156.65 144.08 152.45 149.07 152.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "129.45 162.89 129.45 160.39 113.8 161.07 113.8 164.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "113.8 124.11 106.66 124.11 106.66 113.11 115.05 113.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.45,
    y: 94.17,
    width: 7.6,
    height: 9.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.45,
    y: 78.75,
    width: 7.6,
    height: 11.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.02,
    y: 63.67,
    width: 7.03,
    height: 10.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.05,58.91l1.76-3.29v-5.33s-1.59-3.74-2.95,0h-1.59s-1.59-4.54-2.61,0v5.56s1.36,3.06,1.36,3.06h4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.68,49.61s-.05,8.66.22,18.03c.31,11.06,1.06,23.13,2.84,23.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 128.32,
    y1: 67.42,
    x2: 118.9,
    y2: 67.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 128.32,
    y1: 82.5,
    x2: 119.82,
    y2: 83.83
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.26 95.53 142.26 81.82 140.56 80.11 132.06 80.11 131.15 81.47 131.15 96.9 140.9 96.9 142.26 95.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 131.15,
    y: 56.3,
    width: 12.36,
    height: 2.61,
    transform: "translate(274.66 115.21) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "129 55.28 145.66 55.28 145.66 58.23 206.21 62.43 206.21 60.84 206.21 67.42 206.21 71.95 206.21 76.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146,
    y1: 67.42,
    x2: 206.21,
    y2: 67.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "206.21 71.95 172.56 76.75 144.98 80.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 172.54,
    y1: 81.93,
    x2: 172.56,
    y2: 76.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 144.98,
    y1: 34.34,
    x2: 130.02,
    y2: 34.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.56,28.98c0-.71,3.75-1.32,6.35-1.47,3.13-.18,7.31.15,7.37.91.06.73-3.69,1.86-7.26,1.93-3.07.05-6.46-.68-6.46-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.21,29.09c0-.65-4.07-1.24-7.37-1.25-3.73-.01-7.94.7-7.94,1.36,0,.64,3.92,1.2,7.03,1.25,3.92.06,8.28-.68,8.28-1.36Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 140.56,
    y1: 28.98,
    x2: 134.21,
    y2: 29.09
  }))), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(96.38 71.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(109.43 71.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(96.38 86.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(109.43 86.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(96.38 101.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(109.43 101.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(97.19 121.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(107.81 121.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane1);
export default __webpack_public_path__ + "static/media/plane1.3a2ee9d80bee2e7230dafc8d5a18b0ec.svg";
export { ForwardRef as ReactComponent };